import AnalyticsEngineTealiumBase from "../../../../src/common/analytics/engines/analyticsEngineTealiumBase";
import {
  VIEW_ARTICLE_ALB,
  VIEW_PAGE,
  VIEW_PAGE_IN_BACKGROUND,
} from "../../../../src/common/analytics/analyticsevents";

export default class AnalyticsEngineTealium extends AnalyticsEngineTealiumBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);

    const {
      tealium: { utagDomain, utagPath, utagEnv },
    } = options;

    this.injectUtagConfig({
      domain: utagDomain,
      path: utagPath,
      env: utagEnv,
    });
    this._subscribeToEvents();
  }

  _subscribeToEvents() {
    this._analyticsManagerBase.on(VIEW_ARTICLE_ALB, (data) => {
      if (this.getIsReady()) {
        this._sendAlbView(data);
      }
    });

    this._analyticsManagerBase.on(VIEW_PAGE, (data) => {
      if (this.getIsReady()) {
        this._sendPageView(data);
      }
    });

    this._analyticsManagerBase.on(VIEW_PAGE_IN_BACKGROUND, (data) => {
      if (this.getIsReady()) {
        this._sendPageView(data);
      }
    });
  }

  _sendPageView(data) {
    const { editionToken, bundleDate, pageNumber } =
      this.getPageViewPayload(data);
    window.utag.track(this.trackEventName, {
      page_name: `gaz/sfogliatore/${editionToken}/${bundleDate}/pagina/${pageNumber}`,
    });
  }

  _sendAlbView(data) {
    const { bundleDate, articleTitle, editionToken } =
      this.getAlbViewPayload(data);
    window.utag.track(this.trackEventName, {
      page_name: `gaz/sfogliatore/${editionToken}/${bundleDate}/articoli/${articleTitle}`,
    });
  }
}



// WEBPACK FOOTER //
// ./clients/rcs-gds/js/engines/analyticsEngineTealium.js